<svelte:options accessors/>
<script lang="ts">
    import NauiSwitch from '../atoms/NauiSwitch.svelte';
    import NauiFile from "../atoms/NauiFile.svelte";

    export let title = '';
    export let fields = [];

    function isInput(item: any): boolean {
        const options: Array<boolean> = [];
        options.push(item.type === 'date');
        options.push(item.type === 'password');
        options.push(item.type === 'number');
        options.push(item.type === 'email');
        options.push(item.type === 'text');
        options.push(item.type === 'color');
        return options.some((o: boolean) => o);
    }
</script>
<div>
    <div class="fieldset-header back-secondary px-15 py-ii">
        <strong class="white">{ title }</strong>
    </div>
    <table class="fieldset-table w-100">
        {#each fields || [] as item}
            <tr>
                <td>
                    <p>{ item.label }</p>
                </td>
                <td class="pr-1">
                    <div class="py-ii">
                        {#if isInput(item)}
                            <div>
                                <input class="naui-input w-100"
                                       placeholder={item.placeholder||item.label}
                                       bind:value={item.value}>
                            </div>
                        {:else if item.type === 'select'}
                            <div>
                                <select class="naui-input w-100"
                                        bind:value={item.value}>
                                    <option value={undefined}>{item.placeholder || item.label}</option>
                                    {#each item.options || [] as option}
                                        <option value={option.value}>{option.label}</option>
                                    {/each}
                                </select>
                            </div>
                        {:else if item.type === 'bool'}
                            <NauiSwitch bind:active={item.value}>
                            </NauiSwitch>
                        {:else if item.type === 'textarea'}
                            <div>
                                <textarea class="naui-input w-100"
                                          bind:value={item.value}
                                          rows="10"></textarea>
                            </div>
                        {:else if item.type === 'action'}
                            <div class="action">
                                <i class="fa fa-search"></i>
                            </div>
                        {:else if item.type === 'file'}
                            <div>
                                <NauiFile on:file={(evt)=>item.value = evt.detail}/>
                            </div>
                        {/if}
                    </div>
                </td>
            </tr>
        {/each}
    </table>
</div>
<style>
    .fieldset-header {
        border-radius: 5px 5px 0 0;
    }

    .action {
        width: 25px;
        cursor: pointer;
    }
</style>
